import React from 'react'
import { observer } from 'mobx-react-lite'

import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { TableCell } from '@material-ui/core'

import { MyTableHead } from './MyTableHead'

import { useStore } from '../../hooks/storeHook'
import { useMyProductColumns } from '../../hooks/myProductHooks'

import { MyProductColumnGroupId } from '../../types/myProductColumnGroups'

export const MyProductsTableHead =
  observer(() => {
    const classes = useStyles()

    const {productStore: {myProducts}} = useStore()

    const myProductColumns = useMyProductColumns()

    const getColSpan =
      (group: MyProductColumnGroupId) =>
        myProductColumns.visible.filter(_ => _.group === group).length

    const myColSpan = getColSpan(MyProductColumnGroupId.MyStorage)
    const ozonColSpan = getColSpan(MyProductColumnGroupId.Ozon)
    const wbColSpan = getColSpan(MyProductColumnGroupId.Wildberries)
    const ymColSpan = getColSpan(MyProductColumnGroupId.YandexMarket)

    const hasStoreGroup = (ozonColSpan + wbColSpan + ymColSpan) > 0

    return (
      <MyTableHead
        table={myProducts}
        visibleColumns={myProductColumns.visible}
        groupHeader={<>
          {
            myColSpan > 0 &&
            <TableCell
              colSpan={myColSpan}
              className={clsx(
                classes.groupCell,
                classes.moySklad,
            !hasStoreGroup && classes.groupCellWithoutRightBorder
              )}
            >
              МойСклад
            </TableCell>
          }

          {
            ozonColSpan > 0 &&
            <TableCell
              colSpan={ozonColSpan}
              className={clsx(
                classes.groupCell,
                classes.ozon,
                classes.groupCellWithoutRightBorder
              )}
            >
              Ozon
            </TableCell>
          }

          {
            wbColSpan > 0 &&
            <TableCell
              colSpan={wbColSpan}
              className={clsx(
                classes.groupCell,
                classes.wildberries,
                classes.groupCellWithoutRightBorder
              )}
            >
              Wildberries
            </TableCell>
          }

          {
            ymColSpan > 0 &&
            <TableCell
              colSpan={ymColSpan}
              className={clsx(
                classes.groupCell,
                classes.yandexMarket,
                classes.groupCellWithoutRightBorder
              )}
            >
              Yandex.Market
            </TableCell>
          }
        </>}
      />
    )
  })

const useStyles = makeStyles(
  ({palette}) => ({
      groupCell: {
        padding: '4px 15px',
        borderRight: `2px solid ${palette.mpSkladSecondary.lightGray}`
      },
      groupCellWithoutRightBorder: {
        borderRight: 'none',
        borderTopRightRadius: '5px'
      },
      moySklad: {
        background: palette.mpSkladPrimary.blue,
        color: palette.mpSkladSecondary.lightBlue,
        borderTopLeftRadius: '5px',
        height: '32px'
      },
      ozon: {
        background: '#005BFF',
        color: palette.mpSkladSecondary.lightBlue
      },
      wildberries: {
        background: '#BC3D96',
        color: palette.mpSkladSecondary.lightBlue
      },
      yandexMarket: {
        background: '#FC0',
        color: palette.mpSkladSecondary.lightBlue
      }
    }
  ))